import { render, staticRenderFns } from "./CommunityPage.vue?vue&type=template&id=54cb7ec3"
import script from "./CommunityPage.vue?vue&type=script&lang=js"
export * from "./CommunityPage.vue?vue&type=script&lang=js"
import style0 from "./CommunityPage.vue?vue&type=style&index=0&id=54cb7ec3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports